import { c as _c } from "react/compiler-runtime";
import { Checkbox, Checkmark2Icon, FontWeights, MenuItem, Tooltip } from "@flat-ui";
import { Box, Stack } from "@mui-wrapper";
import { withEllipsis } from "@styles/common-styles";
import { PALETTE_VARS } from "@styles/palette-vars";
/** Renders items inside a filter chip */
export function FilterChipDropdownItem(t0) {
  const $ = _c(32);
  const {
    filterItem,
    isItemSelected,
    onItemClicked,
    shouldShowCheckbox,
    shouldShowCheckIconOnRight,
    shouldAllowLabelTranslation: t1,
    endIcon
  } = t0;
  const shouldAllowLabelTranslation = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== filterItem.id || $[1] !== onItemClicked) {
    t2 = () => onItemClicked(filterItem.id);
    $[0] = filterItem.id;
    $[1] = onItemClicked;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== isItemSelected || $[4] !== shouldShowCheckbox) {
    t3 = shouldShowCheckbox && <Checkbox checked={isItemSelected} />;
    $[3] = isItemSelected;
    $[4] = shouldShowCheckbox;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = isItemSelected ? "primary.main" : "inherit";
  let t5;
  if ($[6] !== t4) {
    t5 = {
      alignItems: "center",
      gap: "5px",
      flexDirection: "row",
      color: t4,
      flex: 1,
      minWidth: 0
    };
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      minWidth: 0,
      ...withEllipsis
    };
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== filterItem.label || $[10] !== shouldAllowLabelTranslation) {
    t7 = shouldAllowLabelTranslation ? filterItem.label : <var>{filterItem.label}</var>;
    $[9] = filterItem.label;
    $[10] = shouldAllowLabelTranslation;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== filterItem.label || $[13] !== t7) {
    t8 = <Tooltip component="div" title={filterItem.label} sx={t6}>{t7}</Tooltip>;
    $[12] = filterItem.label;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== isItemSelected || $[16] !== shouldShowCheckIconOnRight) {
    t9 = shouldShowCheckIconOnRight && isItemSelected && <Checkmark2Icon style={{
      fontSize: "13px",
      color: PALETTE_VARS.primary.main,
      fontWeight: FontWeights.Bold
    }} />;
    $[15] = isItemSelected;
    $[16] = shouldShowCheckIconOnRight;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== endIcon) {
    t10 = endIcon && <Box sx={{
      display: "flex",
      ml: "auto"
    }}>{endIcon}</Box>;
    $[18] = endIcon;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== filterItem.icon || $[21] !== t10 || $[22] !== t5 || $[23] !== t8 || $[24] !== t9) {
    t11 = <Stack sx={t5}>{filterItem.icon}{t8}{t9}{t10}</Stack>;
    $[20] = filterItem.icon;
    $[21] = t10;
    $[22] = t5;
    $[23] = t8;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== filterItem.id || $[27] !== isItemSelected || $[28] !== t11 || $[29] !== t2 || $[30] !== t3) {
    t12 = <MenuItem disableRipple={true} disableTouchRipple={true} key={filterItem.id} value={filterItem.id} selected={isItemSelected} onClick={t2}>{t3}{t11}</MenuItem>;
    $[26] = filterItem.id;
    $[27] = isItemSelected;
    $[28] = t11;
    $[29] = t2;
    $[30] = t3;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  return t12;
}